// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo subscript superscript code',
    'hr bullist numlist link image charmap preview anchor insertdatetime table backcolor fullscreen']

export default toolbar
